module.exports = __webpack_public_path__ + "static/img/wx.18defc9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/wx.png
// module id = TzlQ
// module chunks = 0